import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import { ADMIN_API_BASE } from '../../callApi'

import {
  ResendInvitePayloadType,
  UserInvitePayloadType,
  AdminInvitePayloadType,
} from '../../../types'

export const collection = 'invites'

export const schema = new schemas.Entity(collection)

function isAdmin(
  payload: UserInvitePayloadType | AdminInvitePayloadType
): payload is AdminInvitePayloadType {
  return payload.hasOwnProperty('admin')
}

export const create =
  (callApi: CallApi, apiBase: string) =>
  (_: unknown, payload: ResendInvitePayloadType) =>
    isAdmin(payload)
      ? callApi(
          `${ADMIN_API_BASE}/organizations/${payload.id}/invitations/${payload.email}/resend`,
          schema,
          {
            method: 'POST',
          }
        )
      : callApi(`${apiBase}/invitations/${payload.email}/resend`, schema, {
          method: 'POST',
        })
